import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "wc-card-wrapper" }
const _hoisted_2 = { class: "wc-card__upper" }
const _hoisted_3 = { class: "wc-header-image-badge-wrapper" }
const _hoisted_4 = { class: "product-card-header" }
const _hoisted_5 = { class: "wc-header-image-wrapper" }
const _hoisted_6 = { class: "wc-card-body" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "d-flex flex-column flex-grow-1 wc-card_content" }
const _hoisted_9 = {
  key: 0,
  class: "wc-product-card__brand"
}
const _hoisted_10 = { class: "wc-product-card__name" }
const _hoisted_11 = {
  key: 0,
  class: "wc-product-card__size"
}
const _hoisted_12 = { class: "d-flex justify-content-between flex-grow-1 wc-product-card__price-row" }
const _hoisted_13 = { class: "wc-product-card__bottom-wrapper" }
const _hoisted_14 = { class: "d-flex flex-column justify-content-between" }
const _hoisted_15 = { class: "wc-product-card__atc-zone wc-card-hover" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import WCFavoriteButton from '@/modules/lists/components/WCFavoriteButton/WCFavoriteButton.vue';
import WCProductPriceCardModern from '@/components/WCProductPriceCardModern/WCProductPriceCardModern.vue';
import WCImage from '@/components/WCImage/WCImage.vue';
import useHidePricing from '@/composables/useHidePricing';
import useProductImageInfo from '@/views/ProductDetailPage/composables/useProductImageInfo';
import ItemDetail from '@/models/entities/items/item-detail';
import WCPaymentOptionBadgesModernCard from '@/components/WCPaymentOptionBadgesModernCard/WCPaymentOptionBadgesModernCard.vue';
import WCAddToCartModernCardButton from '@/modules/cart/components/WCAddToCartModernCardButton/WCAddToCartModernCardButton.vue';
import WCAddToCartQuantityAdjusterModernCard from '@/modules/cart/components/WCAddToCartQuantityAdjusterModernCard/WCAddToCartQuantityAdjusterModernCard.vue';
import usePlatform from '@/modules/platform/composables/usePlatform';
import WCProductCardBadgesModern from '../WCProductCardBadgesModern/WCProductCardBadgesModern.vue';

interface Props {
  item: ItemDetail;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WCProductCardModern',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const isCustomer = computed(() => store.getters['user/isCustomer']);
const { shouldHideItemPrices } = useHidePricing();
const { getProductImage, productImgAltText, noProductImageAltText } = useProductImageInfo();
const isScanMode = computed(() => store.getters['user/isCustomerModeScan']);
const { platform } = usePlatform();
const platformModifier = computed(() =>
  platform.value.isMobile ? 'wc-card--mobile' : 'wc-card--desktop',
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["card wc-card", platformModifier.value])
    }, [
      _createVNode(_component_router_link, {
        to: `/i/${_ctx.item.id}`,
        class: "wc-product-card-link",
        "aria-hidden": "true",
        tabindex: "-1"
      }, null, 8, ["to"]),
      _cache[7] || (_cache[7] = _createTextVNode()),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(WCProductCardBadgesModern, { product: _ctx.item }, null, 8, ["product"])
        ]),
        _cache[4] || (_cache[4] = _createTextVNode()),
        _createElementVNode("div", _hoisted_4, [
          (isCustomer.value)
            ? (_openBlock(), _createBlock(WCFavoriteButton, {
                key: 0,
                class: "wc-product-card__favorite-btn",
                item: _ctx.item,
                isMobile: false
              }, null, 8, ["item"]))
            : _createCommentVNode("", true)
        ]),
        _cache[5] || (_cache[5] = _createTextVNode()),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: `/i/${_ctx.item.id}`,
            class: "d-block w-100"
          }, {
            default: _withCtx(() => [
              _createVNode(WCImage, {
                imageSrc: _unref(getProductImage)(_ctx.item.image),
                imageAlt: _unref(productImgAltText)(_ctx.item.name, _ctx.item.brand),
                imageClass: "wc-header-image",
                defaultClass: "d-block w-100 wc-header-image",
                defaultTitle: _unref(noProductImageAltText)(_ctx.item.name)
              }, null, 8, ["imageSrc", "imageAlt", "defaultTitle"])
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _cache[6] || (_cache[6] = _createTextVNode()),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.item.brand)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_router_link, {
                      to: `/b?g=BRD-${_ctx.item.brandId}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.item.brand), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true),
              _cache[1] || (_cache[1] = _createTextVNode()),
              _createVNode(_component_router_link, {
                to: `/i/${_ctx.item.id}`,
                class: "wc-product-card__nameLink"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.item.name), 1),
                  _cache[0] || (_cache[0] = _createTextVNode()),
                  (_ctx.item.size)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.item.size), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _cache[2] || (_cache[2] = _createTextVNode()),
            _createElementVNode("div", _hoisted_12, [
              (!_unref(shouldHideItemPrices))
                ? (_openBlock(), _createBlock(WCProductPriceCardModern, {
                    key: 0,
                    class: "flex-fill font-size-sm",
                    item: _ctx.item
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(WCPaymentOptionBadgesModernCard, {
                item: props.item,
                ebtOnly: true
              }, null, 8, ["item"])
            ])
          ])
        ])
      ]),
      _cache[8] || (_cache[8] = _createTextVNode()),
      _createElementVNode("div", _hoisted_15, [
        (!isScanMode.value)
          ? (_openBlock(), _createBlock(WCAddToCartModernCardButton, {
              key: 0,
              item: _ctx.item
            }, {
              default: _withCtx(() => [
                _createVNode(WCAddToCartQuantityAdjusterModernCard, { item: _ctx.item }, null, 8, ["item"])
              ]),
              _: 1
            }, 8, ["item"]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}
}

})